import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, gbp, errMsg } from "@/lib/api";

export default function GiftCardsTab() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/giftcards").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const resend = async (c) => {
    if (!window.confirm(`Email the gift card to ${c.recipient.email} now?`)) return;
    try { await api.post(`/admin/giftcards/${c.id}/resend`); toast.success("Gift card emailed"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  if (!rows.length) return <p className="mt-6 text-slate-500" data-testid="giftcards-empty">No gift cards sold yet. Customers buy them on the Gift Cards page.</p>;
  return (
    <div className="mt-4 space-y-3" data-testid="giftcards-tab">
      {rows.map((c) => (
        <div key={c.id} className="rounded-2xl bg-white border border-[#EDE4D3] p-5 flex flex-wrap gap-4 items-start" data-testid={`giftcard-${c.code}`}>
          <div className="flex-1 min-w-[240px]">
            <p className="font-mono font-bold text-[#8C2220]">{c.code}</p>
            <p className="text-sm mt-1">To <b>{c.recipient.name}</b> <span className="text-slate-500">({c.recipient.email})</span> · from {c.buyer.name} <span className="text-slate-500">({c.buyer.email})</span></p>
            <p className="text-xs text-slate-500 mt-1">
              Bought {new Date(c.created_at).toLocaleDateString("en-GB")} · {c.delivered ? `Emailed${c.delivered_at ? ` ${new Date(c.delivered_at).toLocaleDateString("en-GB")}` : ""}` : `Scheduled for ${new Date(c.send_date).toLocaleDateString("en-GB")}`}
            </p>
            {c.redemptions?.length > 0 && <p className="text-xs text-slate-500 mt-1">Used on: {c.redemptions.map((r) => `${r.order_number} (${r.amount < 0 ? "+" : "−"}${gbp(Math.abs(r.amount))})`).join(", ")}</p>}
          </div>
          <div className="text-right">
            <p className="font-serif text-xl font-bold" data-testid={`giftcard-balance-${c.code}`}>{gbp(c.balance)} <span className="text-sm font-normal text-slate-500">of {gbp(c.amount)}</span></p>
            <button onClick={() => resend(c)} className="mt-2 rounded-full border border-[#E2D7C3] px-4 py-1.5 text-sm" data-testid={`giftcard-resend-${c.code}`}>{c.delivered ? "Resend email" : "Send now"}</button>
          </div>
        </div>
      ))}
    </div>
  );
}
